export const reaisParaCentavos = (reais: number): number =>
  Math.round(reais * 100);

export const centavosParaReais = (centavos: number): number => centavos / 100;

export const formatarMoeda = (cents: number): string =>
  new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(
    cents / 100,
  );

export const formatarPartesMoeda = (cents: number) => ({
  symbol: "R$",
  integer: Math.floor(cents / 100).toLocaleString("pt-BR"),
  decimal: (cents % 100).toString().padStart(2, "0"),
});